import { render, staticRenderFns } from "./InactiveSubscriptions.vue?vue&type=template&id=16bc7613&lang=pug&"
import script from "./InactiveSubscriptions.vue?vue&type=script&lang=js&"
export * from "./InactiveSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./InactiveSubscriptions.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports